// Professional experience, newest first. Rendered as a stacked timeline.

const experience = [
  {
    id: 'servicenow',
    org: 'ServiceNow',
    href: 'https://servicenow.com/',
    role: 'Software Engineer Intern',
    location: 'Santa Clara, CA',
    dates: 'May 2026 – Jul 2026',
    bullets: [
      'Building a full-stack Accessibility Workspace Hub for the A11y team — replacing manual Excel tracking with a centralized platform for audits, issues, and remediation progress, designed to scale to accessibility teams beyond ServiceNow.',
      "Early adopter and tester for ServiceNow's unreleased AI-native development framework, shipping production features with it and surfacing bugs and usability feedback that informed pre-launch improvements.",
    ],
  },
  {
    id: 'luminosity',
    org: 'The Luminosity Lab @ ASU',
    href: 'https://theluminositylab.com/',
    role: 'Software Engineer & Researcher',
    location: 'Tempe, AZ',
    dates: 'Aug 2025 – Present',
    bullets: [
      'Lead technology strategy and full-stack development for CareAscension, a platform connecting unhoused individuals with shelter resources — partnering directly with the City of Phoenix to turn community feedback into product decisions.',
      'Engineered a full-stack, AI-assisted learning platform for a robotics startup, building the frontend UI and AWS-based backend for interactive STEM education.',
    ],
  },
  {
    id: 'pivotal',
    org: 'Pivotal Energy Solutions',
    href: 'https://pivotalenergysolutions.com/',
    role: 'Software Engineering Intern',
    location: 'Gilbert, AZ',
    dates: 'Apr 2024 – Nov 2025',
    bullets: [
      'Developed and debugged test methods across 50+ files, improving coverage and catching issues before production.',
      'Refactored a legacy codebase from Python 2.7 to 3.12 and worked with senior engineers to optimize API integrations and backend functionality.',
    ],
  },
  {
    id: 'persue',
    org: 'Persue Lab @ ASU',
    href: 'https://persue-lab-asu.github.io/',
    role: 'Security Engineer & Researcher',
    location: 'Tempe, AZ',
    dates: 'Nov 2024 – Jul 2025',
    bullets: [
      'Improved an automated pipeline for Android apps to monitor API logs, streamlining detection of data-misuse patterns.',
      'Analyzed security vulnerabilities and implemented optimizations for data-privacy compliance.',
    ],
  },
  {
    id: 'thecoderschool',
    org: 'theCoderSchool',
    href: 'https://www.thecoderschool.com/locations/gilbert/',
    role: 'Program Manager & Code Tutor',
    location: 'Gilbert, AZ',
    dates: 'Sep 2022 – Jun 2024',
    bullets: [
      'Taught Java, Python, and Scratch to 30+ students in weekly sessions, building a structured curriculum for algorithmic problem-solving.',
      'Designed and led robotics programming camps for 50+ students focused on AI-driven applications.',
    ],
  },
];

export default experience;
